// composables/useTypesenseSearchClient.js
import { inject, ref, watch } from 'vue'
import TypesenseInstantSearchAdapter from 'typesense-instantsearch-adapter'

export const useTypesenseSearchClient = config => {
  const $typesenseServerDefaultOptions = inject('$typesenseServerDefaultOptions')
  const searchClient = ref(null)

  watch([
    () => config.additionalSearchParameters.value,
    () => config.collectionSpecificSearchParameters.value
  ],
  ([additionalSearchParameters, collectionSpecificSearchParameters]) => {
    const adapter = new TypesenseInstantSearchAdapter({
      server: $typesenseServerDefaultOptions,
      additionalSearchParameters,
      collectionSpecificSearchParameters
    })

    searchClient.value = adapter.searchClient
  }, { immediate: true })

  return { searchClient }
}
